<template>
  <div class="ty-main">
  <el-page-header @back="goBack" content=""></el-page-header>
    <div style="display: flex;width: 100%">
        <div class="ty-content white">
            <h1 style="color: #000000;">内容审计/消息类型说明</h1>
            <h4 class="cu">1、文本：</h4>
            <p class="zi">在内外部单聊和群聊中发送的文本类型的消息，包括文本、Emoji表情、URL地址、引用类型的消息内容。</p>
            <h4 class="cu">2、图片：</h4>
            <p class="zi">在内外部单聊和群聊中发送的图片类型的消息；图片的发送方式是在会话窗口通过【图片】上传或直接拖拽图片至会话窗口</p>
            <h4 class="cu">3、撤回：</h4>
            <p class="zi">在内外部单聊和群聊中对已发送的消息进行撤回的操作记录</p>
            <h4 class="cu">4、存档须知：</h4>
            <p class="zi">在外部单聊和群聊中由客户选择的是否同意会话内容存档的操作记录；客户成为好友后，客户在收到的存档须知中可进行三类操作：1、点击【拒绝】，将无法获取到该客户的会话内容；2、拒绝后再点击【同意】，可获取同意后的会话内容；3、不操作或点击【我知道了】，可获取会话内容。</p>
            <h4 class="cu">5、语音：</h4>
            <p class="zi">在内外部单聊和群聊中发送的语音类型的消息</p>
            <h4 class="cu">6、视频：</h4>
            <p class="zi">在内外部单聊和群聊中发送的视频类型的消息</p>
            <h4 class="cu">7、名片：</h4>
            <p class="zi">在内外部单聊和群聊中发送的名片类型的消息，名片分为[企业微信名片]和[微信名片]</p>
            <h4 class="cu">8、位置：</h4>
            <p class="zi">在内外部单聊和群聊中发送的位置类型的消息</p>
            <h4 class="cu">9、表情：</h4>
            <p class="zi">在内外部单聊和群聊中发送的表情类型的消息，表情类型包括企业微信侧和微信侧的原生表情及自定义表情、gif类型的文件，不包含Emoji表情这个属于文本类型</p>
            <h4 class="cu">10、文件：</h4>
            <p class="zi">在内外部单聊和群聊中发送的链接类型的消息，包括浏览器链接、群工具和微文档中的收集表、转发给外部客户的日程等，不包含URL地址这类属于文本类型[图片]类型；从会话窗口【文件】发送的则是[文件]类型，图片、视频、gif都属于此类情况</p>
            <h4 class="cu">11、链接：</h4>
            <p class="zi">在内外部单聊和群聊中发送的文本类型的消息，包括文本、Emoji表情、URL地址、引用类型的消息内容。</p>
            <h4 class="cu">12、小程序：</h4>
            <p class="zi">在内外部单聊和群聊中发送的小程序类型的消息，包括通过工作台发送的会议邀请等</p>
        </div>
        <div class="ty-content white">
            <div  style="margin-top: 42px;"></div>
            <h4 class="cu">13、会话记录：</h4>
            <p class="zi">在内外部单聊和群聊中选中多条消息后进行转发的操作记录，能够转发的消息类型包括文本、图片、视频、位置、文件、链接、会话记录、混合消息；会话记录的发送方式是在会话窗口中选中多条消息后进行合并转发，会话记录再次进行多选合并，最多支持3级</p>
             <h4 class="cu">14、待办：</h4>
            <p class="zi">在内部单聊和群聊中发送的待办类型的消息；待办消息的发送方式是需要点击【保存并发送聊天】才可以作为会话记录被获取</p>
            <h4 class="cu">15、投票：</h4>
            <p class="zi">在内部群聊中发送的投票类型的消息</p>
            <h4 class="cu">16、填表：</h4>
            <p class="zi">在内部群聊中发送的投票类型的消息；填表消息的发送仅老版本支持，新版本该功能升级为【收集表】</p>
            <h4 class="cu">17、红包：</h4>
            <p class="zi">在内部单聊和群聊以及外部企业微信单聊中发送的红包类型的消息</p>
            <h4 class="cu">18、互通红包：</h4>
            <p class="zi">在外部群聊以及外部微信单聊中发送的红包类型的消息</p>
            <h4 class="cu">19、会议邀请：</h4>
            <p class="zi">在内部单聊和群聊中发送的会议邀请类型的消息，包括发出邀请和处理邀请；会议邀请的发送方式需要预约开会类型，语音和视频会议暂不支持会话记录获取；处理邀请时可选择参加、拒绝、待定等；会议邀请类型的发送仅老版本支持，新版本该功能升级为【日程】</p>
            <h4 class="cu">20、在线文档：</h4>
            <p class="zi">在线文档类型的发送仅老版本支持，新版本只有在客户端聊天页面新建在线文档发送才是【在线文档】类型，其他方式发送的在线文档均为【链接】类型</p>
            <h4 class="cu">21、日程：</h4>
            <p class="zi">在内外部单聊和群聊中发送的位置类型的消息；日程消息的发送方式需要在选择日程参与人后点击【保存并发送到聊天】才可以作为会话记录被获取，其中在外部微信单聊中发送时会转为链接类型</p>
            <h4 class="cu">22、混合消息：</h4>
            <p class="zi">在内部单聊和群聊中发送的混合类型的消息，混合消息中可包含文本、图片、表情</p>
            <h4 class="cu">23、语音通话及文档演示：</h4>
            <p class="zi">语音通话为在内外部单聊和内部群聊中发送的语音通话类型的消息，包括语音通话和视频通话都会识别为音频存档消息类型；文档演示为在语音通话中发送的演示文档类型的消息，仅在企业微信侧支持微信侧暂不支持；
语音通话的音频存档消息的发送方式在移动端支持在通话过程中发送演示文档，在客户端支持演示文档及屏幕共享；在内部群聊中发送的语音通话在获取会话记录时会处理在多个独立的单聊里。[图片]类型；从会话窗口【文件】发送的则是[文件]类型，图片、视频、gif都属于此类情况</p>
            <h4 class="cu">24、视频号：</h4>
            <p class="zi">在外部群聊和外部企业微信单聊中由微信客户发送的视频号类型的消息；视频号消息的发送过程中由内部成员或企业微信客户进行转发后转为[链接]类型</p>
        </div>
    </div>
    <div style="text-align: left;background: #fff;">
        <h4 class="cu" style="margin-left: 20px;">备注：</h4>
                <p class="zi">与企业微信同步会话消息的频率说明：获取会话消息的频率为3分钟，获取可下载的媒体文件类型的频率为5分钟。</p>
        </div>
  </div>
</template>
<script>

export default {
    methods: {
        goBack() {
            this.$router.push({ path: '/audit' } )
        }
    }
}
</script>

<style lang="scss" scoped>
 ::v-deep.ty-breadcrumb{
    text-align: left;
    .ty-breadcrumb-item{
        font-size: 18px;
        font-family: Source Han Sans CN;
        font-weight: 600;
        line-height: 28px;
        color: rgba(0, 0, 0, 0.85);
        opacity: 1;
    }
}
::v-deep.ty-content{
    width: 50%;
    text-align: left;
    .cu{
        font-weight: 600;
    }
    .zi{
        text-indent: 2em;
    }
}
::v-deep.ty-main .ty-content.white{
    box-shadow: none;
    margin-top: 0;
}
.cu{
        font-weight: 600;
    }
    .zi{
        text-indent: 2em;
    }
</style>
